import React from 'react'
import {
  ResidentAppErrorHandling,
  ResidentAppShell,
} from '@pandiafi/components'

import { shouldRegionCatchError } from '../utils/shouldRegionCatchError'

import { ResidentAppRouterLink } from 'components/ResidentAppRouterLink/ResidentAppRouterLink'

const errorHandling: ResidentAppErrorHandling = {
  shouldCatch: shouldRegionCatchError,
}

interface AppShellProps {
  topBar?: React.ReactNode
  footer?: React.ReactNode
  children: React.ReactNode
}

/**
 * The resident app's page frame: `ResidentAppShell` with the router link
 * adapter and the app's error policy. `topBar` and `footer` must not render
 * their own `<header>` or `<footer>`; the shell provides the landmarks.
 */
export const AppShell: React.FC<AppShellProps> = ({
  topBar,
  footer,
  children,
}) => (
  <ResidentAppShell
    topBar={topBar}
    footer={footer}
    linkComponent={ResidentAppRouterLink}
    errorHandling={errorHandling}
  >
    {children}
  </ResidentAppShell>
)
